import { useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

const useCurrentTab = (tabs) => {
  const location = useLocation();
  const { path: routePath } = useRouteMatch();

  const currentTabIndex = useMemo(() => {
    const currentPath = location.pathname.replace(/\/$/, '');
    if (currentPath === routePath) {
      return 0;
    }
    const tabIndex = tabs.findIndex(
      (tab) => currentPath === `${routePath}/${tab.path}`
        || currentPath.startsWith(`${routePath}/${tab.path}/`),
    );
    return tabIndex !== -1 ? tabIndex : 0;
  }, [location.pathname, routePath, tabs]);

  return currentTabIndex;
};

export default useCurrentTab;
